import {ModuleEnum} from 'src/api/ProactApiClient';
import {InspectionCustomOperations} from './customOperations';
import {useModulePermissions} from './useModulePermissions';

// Also backs Device/EquipmentType permission checks — they share
// ModuleEnum.Inspections rather than having a standalone module enum.
export function useInspectionPermissions() {
  return useModulePermissions(ModuleEnum.Inspections, InspectionCustomOperations);
}
